<template>
  <v-dialog content-class="v-dialog--scroll" v-model="dialog" scrollable max-width="50%">
    <template v-if="computeType === 'add'" v-slot:activator="{ on }">
      <a  v-on="on" class="body-2 font-weight-bold d-inline">
        <span class="black--text">{{$t('planner.assign')}}</span>
      </a>
    </template>
    <template v-else v-slot:activator="{ on }">
        <span v-on="on" style="color: #eeeeee" class="v-chip--custom--text">
          {{chipText}}
        </span>
    </template>
    <template>
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="1">
              <v-icon v-if="assigmentLevel.name !== 'Shipment Type'" @click="handleBack(assigmentLevel.name)">
                fa-chevron-left
              </v-icon>
            </v-col>
            <v-col offset="4" cols="7" class="justify-center">
              {{assigmentLevel.name}}
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-list class="v-dialog--scroll-list">
            <template v-if="assigmentLevel.name === 'Shipment Type'">
              <template v-for="(type, index) in assigmentLevel.list">
                <v-list-item ripple  @click="handleSelect(index)"  :key="'type_' + index">
                    <v-list-item-content>
                      <v-list-item-title>{{type.name}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider :key="index"></v-divider>
              </template>
            </template>
            <template v-if="assigmentLevel.name === '1PL'">
              <template v-for="(type, index) in assigmentLevel[select1pl]">
                <v-list-item ripple @click="handleSelect1PL(type, select1pl)" v-if="select1pl === 'vehicles'" :key="'type_' + index">
                  <v-list-item-avatar>
                      <v-icon>
                        fa-truck
                      </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{type.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
                <v-list-item ripple @click="handleSelect1PL(type, select1pl)" v-if="select1pl === 'drivers'" :key="'type_' + index">
                  <v-list-item-content>
                    <v-list-item-title> {{type.firstname}} {{type.lastname}}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-avatar>
                    <img :src="type.avatar">
                  </v-list-item-avatar>
              </v-list-item>
              <v-divider :key="index"></v-divider>
              </template>
            </template>
            <template v-if="assigmentLevel.name === '2PL'">
              <template v-for="(type, index) in assigmentLevel[select2pl]">
                <v-list-item ripple v-if="select2pl === 'list'"  @click="handleSelect2PL(type, select2pl)"  :key="'type_' + index">
                  <v-list-item-avatar>
                    <img :src="type.avatar">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title> {{type.name}}</v-list-item-title>
                  </v-list-item-content>
                <v-list-item-action>
                  <v-btn text :color="type.managed ? 'green lighten-4': 'red lighten-4'">{{type.managed ? 'Managed': 'Not Managed'}}</v-btn>
                </v-list-item-action>
                </v-list-item>
                <v-list-item ripple @click="handleSelect2PL(type, select2pl)" v-if="select2pl === 'vehicles'" :key="'type_' + index">
                  <v-list-item-avatar>
                      <v-icon>
                        fa-truck
                      </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{type.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
                <v-list-item ripple @click="handleSelect2PL(type, select2pl)" v-if="select2pl === 'drivers'" :key="'type_' + index">
                  <v-list-item-content>
                    <v-list-item-title> {{type.firstname}} {{type.lastname}}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-avatar>
                    <img :src="type.avatar">
                  </v-list-item-avatar>
              </v-list-item>
                <v-divider :key="index"></v-divider>
              </template>
            </template>
            <template v-if="assigmentLevel.name === '3PL'">
              <template v-if="!edit3plFlag">
                <template v-for="(type, index) in assigmentLevel.list">
                  <v-list-item :key="'type_' + index">
                    <v-list-item-avatar>
                      <img :src="type.avatar">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{type.name}}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{type.info}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn text small>
                        {{type.status}}
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-icon ripple @click="edit3plShipment(index)">
                        fa-pencil-alt
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider :key="index"></v-divider>
                </template>
              </template>
              <template v-else>
                <v-row>
                  <v-col cols="12">
                    <v-form>
                      <v-text-field label="Company" v-model="form3pl.company" required></v-text-field>
                      <v-text-field label="Company Info" v-model="form3pl.info" required></v-text-field>
                      <v-text-field label="Company Avatar" v-model="form3pl.avatar"></v-text-field>
                      <v-select v-if="appendOfferFlag" label="Company Status" @input="handle3plStatus" v-model="form3pl.status" :items="companies3PLSelectStatus" required>
                        <template  #prepend-inner>
                          <v-btn text>
                            {{form3pl.appendOffer}}
                          </v-btn>
                        </template>
                      </v-select>
                      <v-select v-if="!appendOfferFlag" label="Company Status" @input="handle3plStatus" v-model="form3pl.status" :items="companies3PLSelectStatus" required>
                      </v-select>
                      <v-btn @click="dialog = false">
                        Save
                      </v-btn>
                    </v-form>
                  </v-col>
                </v-row>
              </template>
            </template>
             <template v-if="assigmentLevel.name === 'Express'">
              <template v-for="(type, index) in assigmentLevel['list']">
                <v-list-item ripple  @click="handleSelectExpress(type)"  :key="'type_' + index">
                  <v-list-item-avatar>
                    <img :src="type.avatar">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title> {{type.name}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="index"></v-divider>
              </template>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  name: 'AssignShipmentType',
  props: {
    selectDriver: Function,
    type: { type: String, default: 'add' },
    hover: { type: Boolean, default: false },
    handleCloseMenu: { type: Function, default: () => 1 },
    chipText: { type: String, default: '' }
  },
  data () {
    return {
      dialog: false,
      availableAssigments: {
        name: this.$i18n.t('planner.shipment_type'),
        list: [
          { name: '1PL', list: [], drivers: [], vehicles: [] },
          { name: '2PL', list: [], drivers: [], vehicles: [] },
          { name: '3PL', list: [] },
          { name: 'Express', list: [] }
        ]
      },
      level: [],
      // 1pl
      select1pl: 'vehicles',
      availabeDrivers: [],
      firstnames: ['George', 'Nick', 'Anna', 'John'],
      lastnames: ['Doe', 'Leider', 'Connors', 'Baker'],
      types: ['1PL', '2PL', '3PL', 'Express'],
      vehicles: ['Volvo FM9 340 (1AA1706)', 'DAF 105 XF 460 (1AA1730)', 'Scania G440 440 (1AA4569)', 'IVECO STRALIS 460 (1AB4534)', 'Mercedes Benz AXOR 1824 240 (1DA8922)', 'Scania P270 270 (1GF2133)'],
      assign1pl: {},
      // 2pl
      select2pl: 'list',
      assign2pl: {},
      companies: ['UPS Supply Chain Solutions', 'J.B. Hunt Transport Services', 'Exel', 'Ryder Supply Chain Solutions', 'C.H. Robinson Worldwide', 'Ceva Logistics', 'AmeriCold', 'UTi WorldWide', 'Schneider'],
      companiesLogos: ['https://logo.clearbit.com/ups.com', 'https://logo.clearbit.com/jbhunt.com', 'https://logo.clearbit.com/exel.com.mx', 'https://logo.clearbit.com/ryder.com', 'https://logo.clearbit.com/chrobinson.com', 'https://logo.clearbit.com/chrobinson.com', 'https://logo.clearbit.com/americold.com', 'https://logo.clearbit.com/utimf.com', 'https://logo.clearbit.com/schneider.com'],
      // Express
      assignExpress: {},
      companiesExpress: ['PPL', 'DHL Express', 'DPD'],
      companiesExpressLogos: ['https://logo.clearbit.com/ppluk.com', 'https://logo.clearbit.com/dhl.it', 'https://logo.clearbit.com/dpd.com'],
      // 3PL
      assign3PL: {},
      form3pl: {
        company: '',
        info: '',
        avatar: null,
        status: null,
        appendOffer: '()'
      },
      appendOfferFlag: false,
      companies3PL: ['DHL Global Forwarding', 'Kuehne-Nagel', 'C.H. Robinson Worldwide', 'Expeditors', 'Hub Group'],
      companies3PLLogos: ['https://logo.clearbit.com/logistics.dhl', 'https://logo.clearbit.com/kuehne-nagel.com', 'https://logo.clearbit.com/chrobinson.com', 'https://logo.clearbit.com/expeditors.com', 'https://logo.clearbit.com/hubgroup.com'],
      companies3PLStatus: ['Pending', 'Offer: (80000)', 'Reject', 'Offer: (30000)', 'Offer: (50000)'],
      companies3PLSelectStatus: ['Pending', 'Reject', 'Offer', 'Accepted'],
      edit3plFlag: false,
      edit3plStatus: 1,
      edit3plOffer: ''
    }
  },
  mounted () {
    for (let index = 0; index < 10; index++) {
      // 1PL
      let element = {
        id: '000' + index,
        firstname: this.firstnames[Math.floor(Math.random() * this.firstnames.length)],
        lastname: this.lastnames[Math.floor(Math.random() * this.lastnames.length)],
        avatar: `https://cdn.vuetifyjs.com/images/lists/${Math.floor(Math.random() * 5) + 1}.jpg`,
        type: '1PL'
      }
      let vehicle = { id: '00' + index, name: this.vehicles[Math.floor(Math.random() * this.vehicles.length)] }
      this.availableAssigments.list[0].drivers.push(element)
      this.availableAssigments.list[0].vehicles.push(vehicle)
      // 1PL
      // 2PL
      let company = {
        id: '0' + index,
        name: this.companies[index],
        avatar: this.companiesLogos[index],
        managed: index % 2 === 0
      }
      this.availableAssigments.list[1].list.push(company)
      this.availableAssigments.list[1].drivers.push(element)
      this.availableAssigments.list[1].vehicles.push(vehicle)
      // 2PL
    }
    for (let index = 0; index < 3; index++) {
      let companyExpress = {
        id: '0' + index,
        name: this.companiesExpress[index],
        avatar: this.companiesExpressLogos[index]
      }
      this.availableAssigments.list[3].list.push(companyExpress)
    }
    for (let index = 0; index < 5; index++) {
      let company3PL = {
        id: '0' + index,
        name: this.companies3PL[index],
        info: 'Athens: +30 210 2593000, Email: info@dhl.com',
        avatar: this.companies3PLLogos[index],
        status: this.companies3PLStatus[Math.floor(Math.random() * this.companies3PLStatus.length)]
      }
      this.availableAssigments.list[2].list.push(company3PL)
    }
  },
  methods: {
    handleSelect (index) {
      this.level.push(index)
    },
    handleBack (type) {
      switch (type) {
        case '1PL':
          if (this.select1pl === 'vehicles') {
            this.level = []
          } else {
            this.select1pl = 'vehicles'
          }
          break
        case '2PL':
          if (this.select2pl === 'list') {
            this.level = []
          } else if (this.select2pl === 'vehicles') {
            ['assign2pl'].forEach((object) => {
              Object.keys(this[object]).forEach((key) => {
                delete this[object][key]
              })
            })
            this.select2pl = 'list'
          } else {
            ['assign2pl'].forEach((object) => {
              Object.keys(this[object]).forEach((key) => {
                delete this[object][key]
              })
            })
            this.select2pl = 'vehicles'
          }
          break
        case '3PL':
          this.level = []
          // this.dialog = false
          break
        case 'Express':
          this.level = []
          break
      }
    },
    handleSelect1PL (object, type) {
      if (type === 'vehicles') {
        this.assign1pl = { ...this.assign1pl, subtitle: object.name }
        this.select1pl = 'drivers'
      } else if (type === 'drivers') {
        this.assign1pl = { ...this.assign1pl, avatar: object.avatar, title: object.firstname + ' ' + object.lastname, type: '1PL' }
        this.select1pl = 'vehicles'
        this.selectDriver({ ...this.assign1pl })
        // this.emptyObjectSelection()
        this.handleCloseMenu()
        this.dialog = false
      }
    },
    handleSelect2PL (object, type) {
      if (object.managed !== undefined) {
        this.assign2pl = { ...this.assign2pl, managed: object.managed }
      }
      if (this.assign2pl.managed) {
        if (type === 'list') {
          this.assign2pl = { ...this.assign2pl, title: object.name, subtitle: '', avatar: object.avatar, type: '2PL' }
          this.select2pl = 'vehicles'
        } else if (type === 'vehicles') {
          this.assign2pl = { ...this.assign2pl, subtitle2: object.name }
          this.select2pl = 'drivers'
        } else if (type === 'drivers') {
          this.assign2pl = { ...this.assign2pl, avatar2: object.avatar, subtitle: object.firstname + ' ' + object.lastname }
          this.selectDriver({ ...this.assign2pl })
          // this.emptyObjectSelection()
          this.select2pl = 'list'
          this.handleCloseMenu()
          this.dialog = false
        }
      } else {
        this.assign2pl = { ...this.assign2pl, title: object.name, subtitle: '', avatar: object.avatar, type: '2PL' }
        this.selectDriver({ ...this.assign2pl })
        // this.emptyObjectSelection()
        this.handleCloseMenu()
        this.dialog = false
      }
    },
    edit3plShipment (index) {
      this.edit3plFlag = true
      this.form3pl.company = this.assigmentLevel.list[index].name
      this.form3pl.avatar = this.assigmentLevel.list[index].avatar
      this.form3pl.info = this.assigmentLevel.list[index].info
      if (this.assigmentLevel.list[index].status.indexOf('Offer') !== -1) {
        this.form3pl.status = 'Offer'
        this.form3pl.appendOffer = this.assigmentLevel.list[index].status
        this.appendOfferFlag = true
      } else {
        this.form3pl.status = this.assigmentLevel.list[index].status
        this.form3pl.appendOffer = '()'
      }
    },
    handle3plStatus () {
      if (this.form3pl.status.indexOf('Offer') === -1) {
        this.appendOfferFlag = false
      } else {
        this.appendOfferFlag = true
      }
    },
    handleSelectExpress (object) {
      this.assignExpress = { ...this.assignExpress, avatar: object.avatar, title: object.name, subtitle: 'Express', type: 'Express' }
      this.selectDriver({ ...this.assignExpress })
      // this.emptyObjectSelection()
      this.handleCloseMenu()
      this.dialog = false
    },
    emptyObjectSelection () {
      ['assign1pl', 'assign2pl', 'assignExpress', 'form3pl'].forEach((object) => {
        Object.keys(this[object]).forEach((key) => {
          delete this[object][key]
        })
      })
      this.level = []
      this.edit3plFlag = false
    }
  },
  computed: {
    computeType () {
      return this.type
    },
    assigmentLevel () {
      let array = { name: '', list: [] }
      let stringPath = ''
      this.level.forEach((level) => {
        stringPath += `.list[${level}]`
      })
      const level = String.prototype.split.call(stringPath, /[,[\].]+?/).filter(Boolean).reduce((res, key) => (res !== null && res !== undefined) ? res[key] : res, this.availableAssigments)
      if (level !== undefined) {
        array = { ...array, ...level }
      }
      return array
    }
  },
  watch: {
    dialog: function () {
      this.emptyObjectSelection()
    }
  }
}
</script>

<style lang="scss" scoped>
.v-chip--custom--text {
    padding-left: 5%;
    max-width: 90%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
  }
</style>
